import { React } from "react";
import { motion, AnimatePresence } from "motion/react";

const WordByWordAnimation = ({ text }) => {
  // Split the texts into words
  const textA = text.split(" ");

  // Animation Variants
  const wordVariants = {
    hidden: { opacity: 0, y: 50 }, // Words start off-screen
    visible: { opacity: 1, y: 0 }, // Animate to visible
    exit: { opacity: 0, y: -50 }, // Words exit off-screen
  };

  return (
    <div className="text-animation-container" style={{ textAlign: "center" }}>
      <div style={{ position: "relative" }}>
        <AnimatePresence mode="wait">
          <motion.div
            key="textA"
            className="compat-text-headline light-headline"
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            {textA.map((word, index) => (
              <motion.span
                key={word + index}
                variants={wordVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                transition={{
                  duration: 0.5,
                  delay: index * 0.2, // Delay each word animation
                }}
                style={{
                  display: "inline-block",
                }}
              >
                {word}
              </motion.span>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default WordByWordAnimation;
